import { Link } from "react-router-dom";
import Reveal from "@/components/feature/Reveal";
import MediaFrame from "@/components/feature/MediaFrame";
import SectionHeading from "@/components/feature/SectionHeading";
import { mainTreatments } from "@/mocks/treatments";

export default function MainTreatments() {
  return (
    <section id="treatments" className="bg-background-100 py-16 md:py-20 lg:py-24">
      <div className="u-container">
        <Reveal>
          <SectionHeading en="TREATMENT MENU" jp="SBDCの美容医療" align="center" className="mx-auto" />
        </Reveal>

        <div className="mt-14 flex flex-col gap-16 md:mt-20 md:gap-24">
          {mainTreatments.map((treatment, index) => {
            const reversed = index % 2 === 1;
            return (
              <Reveal key={treatment.id} delay={80}>
                <div id={treatment.id} data-anchor className="flex flex-col gap-8 lg:grid lg:grid-cols-2 lg:items-center lg:gap-14">
                  <div className={reversed ? "lg:order-2" : ""}>
                    <MediaFrame
                      src={treatment.image}
                      alt={treatment.imageAlt}
                      objectPosition="object-center"
                      className="h-[260px] w-full sm:h-[340px] lg:h-[420px]"
                    />
                  </div>

                  <div className={reversed ? "lg:order-1" : ""}>
                    <span className="font-label text-[11px] tracking-[0.25em] text-secondary-600">
                      {String(index + 1).padStart(2, "0")}
                    </span>
                    <span className="en-eyebrow mt-4 block text-[10px] text-foreground-500 md:text-[11px]">
                      {treatment.en}
                    </span>
                    <h3 className="mt-4 font-heading text-2xl text-foreground-950 md:text-[28px]">
                      {treatment.jp}
                    </h3>
                    <p className="mt-6 font-heading text-[17px] leading-[1.9] text-foreground-900 whitespace-pre-line md:text-lg">
                      {treatment.copy}
                    </p>
                    <p className="mt-5 max-w-md text-[13px] leading-[2] text-foreground-700 md:text-sm">
                      {treatment.description}
                    </p>
                    <ul className="mt-7 flex flex-wrap gap-2">
                      {treatment.items.map((item) => (
                        <li
                          key={item}
                          className="rounded-full border border-background-300 px-3.5 py-1.5 text-[11px] text-foreground-700 md:text-xs"
                        >
                          {item}
                        </li>
                      ))}
                    </ul>
                    <Link
                      to={treatment.href}
                      className="group mt-9 inline-flex items-center gap-3 border-b border-foreground-950/25 pb-1 text-[13px] text-foreground-900 transition-colors hover:border-accent-600 hover:text-accent-700 md:text-sm"
                    >
                      {treatment.cta}
                      <i
                        className="ri-arrow-right-line transition-transform group-hover:translate-x-1"
                        aria-hidden
                      />
                    </Link>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}